
export function formatNumber (x) {  
    if (x) {
        x = parseFloat(x)
        x = x.toFixed(3)
        x = parseFloat(x)
        // return numberWithCommas(x)
        return x.toLocaleString('us-US')
    }
    return x
}

export function numberWithCommas(x) {
    if (x) {
        x = x.toString();
        var pattern = /(-?\d+)(\d{3})/
        while (pattern.test(x))
            x = x.replace(pattern, "$1,$2")
        // x = x.replace('.000','')
        return x
        }
}
